export const ErrorString = Object.freeze({
    MoreThanOneElement: "Sequence contains more than one element",
    MoreThanOneMatchingElement: "Sequence contains more than one matching element",
    NoElements: "Sequence contains no elements",
    NoMatch: "Sequence contains no matching element",
});
